var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#449DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 6.79688L16.7578 18H14.6562L12.5234 10.1641C12.4349 9.83073 12.3802 9.46615 12.3594 9.07031H12.3281C12.3021 9.4401 12.2396 9.79948 12.1406 10.1484L10 18H7.85156L4.71875 6.79688H6.75781L8.78906 15C8.8724 15.3438 8.92448 15.7031 8.94531 16.0781H8.98438C9.00521 15.8125 9.07812 15.4531 9.20312 15L11.5 6.79688H13.4141L15.5391 15.0625C15.612 15.3438 15.6667 15.6771 15.7031 16.0625H15.7344C15.75 15.8021 15.8099 15.4583 15.9141 15.0312L17.9062 6.79688H19.8281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.e184db5d98625bcc1e25c6be02572bf9.svg";
export { ForwardRef as ReactComponent };